import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLucaWithSparkles = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1266_668)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M50.7 8C50.7 7.9 50.6 7.8 50.5 7.8L48.7 7.3C47 6.8 45.7 5.5 45.2 3.8L44.7 2C44.7 1.8 44.4 1.7 44.2 1.8C44.2 1.8 44 1.9 44 2L43.5 3.8C43 5.5 41.7 6.8 40 7.3L38.2 7.8C38 7.8 37.9 8 38 8.2C38 8.3 38.1 8.4 38.2 8.4L40 8.9C41.7 9.4 43 10.7 43.5 12.4L44 14.2C44 14.4 44.2 14.5 44.4 14.4C44.5 14.4 44.6 14.3 44.6 14.2L45.1 12.4C45.6 10.7 46.9 9.4 48.6 8.9L50.4 8.4C50.6 8.4 50.7 8.2 50.6 8H50.7Z",
				fill: "#C476D2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M49.1 2.2H50.4V3.5C50.4 3.7 50.5 3.8 50.7 3.8C50.9 3.8 51 3.7 51 3.5V2.2H52.3C52.5 2.2 52.6 2.1 52.6 1.9C52.6 1.7 52.5 1.6 52.3 1.6H51V0.3C51 0.1 50.9 0 50.7 0C50.5 0 50.4 0.1 50.4 0.3V1.6H49.1C48.9 1.6 48.8 1.7 48.8 1.9C48.8 2.1 48.9 2.2 49.1 2.2Z",
				fill: "#C476D2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M50.6 3.7C50.4 3.7 50.3 3.5 50.3 3.4V2.2H49.1C48.9 2.2 48.8 2 48.8 1.9C48.8 1.8 49 1.6 49.1 1.6H50.3V0.3C50.3 0.1 50.5 0 50.6 0C50.7 0 50.9 0.2 50.9 0.3V1.5H52.1C52.3 1.5 52.4 1.7 52.4 1.8C52.4 1.9 52.2 2.1 52.1 2.1H50.9V3.3C50.9 3.5 50.7 3.6 50.6 3.6V3.7ZM49.1 1.6C49 1.6 48.9 1.7 48.9 1.8C48.9 1.9 49 2 49.1 2H50.4V3.3C50.4 3.4 50.5 3.5 50.6 3.5C50.7 3.5 50.8 3.4 50.8 3.3V2H52.1C52.2 2 52.3 1.9 52.3 1.8C52.3 1.7 52.2 1.6 52.1 1.6H50.8V0.3C50.8 0.2 50.7 0.1 50.6 0.1C50.5 0.1 50.4 0.2 50.4 0.3V1.6H49.1Z",
				fill: "#C476D2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M53.3 14.5L52.5 14.3C51.8 14.1 51.2 13.5 51 12.8L50.8 12C50.8 12 50.7 11.9 50.6 12L50.4 12.8C50.2 13.5 49.6 14.1 48.9 14.3L48.1 14.5C48.1 14.5 48 14.6 48.1 14.7L48.9 14.9C49.6 15.1 50.2 15.7 50.4 16.4L50.6 17.2C50.6 17.2 50.7 17.3 50.8 17.2L51 16.4C51.2 15.7 51.8 15.1 52.5 14.9L53.3 14.7C53.3 14.7 53.4 14.6 53.3 14.5Z",
				fill: "#C476D2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55.3 26.3L28.6 9.9C28.2 9.7 27.8 9.7 27.4 9.9L6.6 22C6.2 22.2 6 22.6 6 23V45.1C6 45.5 6.2 45.9 6.5 46.1L34.6 63.8C35 64 35.4 64 35.8 63.8L55.3 52.9C55.7 52.7 55.9 52.3 55.9 51.9V27.2C55.9 26.8 55.7 26.4 55.4 26.2L55.3 26.3Z",
				fill: "url(#paint0_linear_1266_668)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15 31.9C16 31.9 16.9 32.7 16.9 33.8V37C16.9 38 16.1 38.9 15 38.9C14 38.9 13.1 38.1 13.1 37V33.8C13.1 32.8 13.9 31.9 15 31.9Z",
				fill: "#080E49"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.4 37.9C25.4 37.9 26.3 38.7 26.3 39.8V43C26.3 44 25.5 44.9 24.4 44.9C23.4 44.9 22.5 44.1 22.5 43V39.8C22.5 38.8 23.3 37.9 24.4 37.9Z",
				fill: "#080E49"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35.8 63.9L55.3 53C55.7 52.8 55.9 52.4 55.9 52V27.3C55.9 27 55.9 26.8 55.7 26.6L35.7 36.7C35.3 36.9 35.1 37.3 35.1 37.7V64.1C35.3 64.1 35.6 64.1 35.8 64V63.9Z",
				fill: "url(#paint1_linear_1266_668)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_1266_668",
			x1: 6,
			y1: 36.9,
			x2: 55.9,
			y2: 36.9,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#9573DA" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#C476D2"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FF6A7F"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_1266_668",
			x1: 35.1,
			y1: 45.3,
			x2: 55.9,
			y2: 45.3,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#9958A5" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CC6683"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1266_668",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 64,
				height: 64,
				fill: "white"
			})
		})
	] })]
});
export default SvgLucaWithSparkles;
